import { useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact/dialog";
import { Tooltip } from "primereact/tooltip";
import CalculadoraTarifaDialog from "./CalculadoraTarifaDialog";

const headerConInfo = (titulo, texto) => (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.25rem", whiteSpace: "nowrap" }}>
        <span>{titulo}</span>
        <i
            className="pi pi-info-circle unicos-info-icon"
            data-pr-tooltip={texto}
            data-pr-position="top"
            style={{ fontSize: "0.85rem", color: "#1976D2", cursor: "help" }}
        />
    </div>
);

const ServiciosUnicosDataTable = ({
    serviciosUnicos,
    loading,
    cotizacion,
    handleTablaChange,
    handleNewTramoCuota,
    handleBorrarLinea,
    handleTramoConfirmacionCuota,
    cobroOptions,
    monedaOptions,
    showTramoModalUnico,
    setShowTramoModalUnico,
    nombreCuadro,
    cuotas,
    setCuotas,
    maxAmountOfCuotas,
    itemCuotas
    }) => {

    const [calcRow, setCalcRow] = useState(null);

    return (
        <>
        {serviciosUnicos.length > 0 && (
            <>
            {/* HEAD */}
            <div
                className="mt-4"
                style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                }}
            >
                <h5>TARIFA UNICA (CAPEX)</h5>
            </div>
            
            {/* BODY */}
            <DataTable 
                value={serviciosUnicos} 
                className="p-datatable-gridlines" 
                loading={loading}
                showGridlines 
                header={`Servicios Únicos`}
                emptyMessage="No seleccionó servicios"
                //rowClassName={(rowData) => rowData.isMask ? 'mask-row' : ''}
            >
                <Column
                field="es_union"
                header="Estado"
                body={(rowData) => (
                    <>
                    <div>
                        <Button
                            icon="pi pi-check"
                            className="p-button-rounded p-button-success p-button"
                            outlined
                            tooltip="Servicio Único Disponible"
                            tooltipOptions={{ position: "top" }}
                        />
                         {/* )} */}
                    </div>
                    </>
                )}
                />

                <Column 
                field="descripcion" 
                header="Nombre" 
                />

                <Column 
                field="tramo" 
                header="Cuota" 
                body={
                    (rowData) => rowData.tramo === "null" ? "" : rowData.tramo
                }
                />

                <Column
                header="Doc. Cobro"
                body={(rowData) => (
                    <Dropdown
                    value={rowData.cobro}
                    options={cobroOptions}
                    onChange={(e) => {
                        // if (rowData.isMask) {
                        // handleMaskChange(rowData, e.value, "unicos", "cobro");
                        // } else {
                        handleTablaChange(rowData, e.value, "unicos", "cobro");
                        //}
                    }}
                    optionLabel="label"
                    optionValue="value"
                    placeholder={rowData.cobro}
                    disabled={cotizacion?.estado.estado === "ASIGNACIÓN" || 
                        cotizacion?.estado.estado === "ANULADA" ||
                        cotizacion?.estado.estado === "RECHAZADA"}
                    />
                )}
                />

                <Column
                header={headerConInfo("Moneda", "Moneda en que se cobra la tarifa al cliente")}
                body={(rowData) => {
                    const filteredOptions = monedaOptions.filter(
                    (item) => item.idEmpresa === rowData.id_empresa
                    );
                    return (
                    <Dropdown
                        value={rowData.moneda}
                        options={filteredOptions}
                        onChange={(e) => {
                        // if (rowData.isMask) {
                        //     handleMaskChange(rowData, e.value, "unicos", "moneda");
                        // } else {
                            handleTablaChange(rowData, e.value, "unicos", "moneda");
                        //}
                        }}
                        optionLabel="codigo"
                        optionValue="codigo"
                        placeholder={rowData.moneda}
                        disabled={cotizacion?.estado.estado === "ASIGNACIÓN" || 
                        cotizacion?.estado.estado === "ANULADA" ||
                        (rowData.tramo && rowData.tramo.includes("Cuota")) || 
                        cotizacion?.estado.estado === "RECHAZADA"
                        } 
                    />
                    );
                }}
                />

                <Column
                header={headerConInfo("Tarifa Cliente", "Tarifa pactada con el cliente en la moneda seleccionada")}
                body={(rowData) => (
                    <div style={{ display: "flex", alignItems: "center", gap: "0.25rem" }}>
                    <InputNumber
                    value={rowData.tarifa_cliente}
                    onChange={(e) => {
                        // if (rowData.isMask) {
                        //     handleMaskChange(rowData, e.value, "unicos", "tarifa_cliente");
                        // } else {
                            handleTablaChange(
                                rowData,
                                e.value,
                                "unicos",
                                "tarifa_cliente"
                            );
                        //}
                    }}
                    locale="es-CL"
                    mode="decimal"
                    maxFractionDigits={4}
                    disabled={cotizacion?.estado.estado === "ASIGNACIÓN" ||
                        cotizacion?.estado.estado === "ANULADA" || 
                        cotizacion?.estado.estado === "RECHAZADA"}
                    />
                    <Button
                        icon="pi pi-calculator"
                        className="p-button-rounded p-button-secondary p-button-text"
                        tooltip="Calcular tarifa desde el monto deseado"
                        tooltipOptions={{ position: "top" }}
                        disabled={cotizacion?.estado.estado === "ASIGNACIÓN" ||
                            cotizacion?.estado.estado === "ANULADA" ||
                            cotizacion?.estado.estado === "RECHAZADA"}
                        onClick={() => setCalcRow(rowData)}
                    />
                    </div>
                )}
                />

                {cotizacion?.estado.estado !== "ASIGNACIÓN" && (
                <Column
                    header="Acción"
                    style={{ minWidth: "120px" }}
                    body={(rowData) => (
                    <>
                        <Button
                        icon="pi pi-plus"
                        className="p-button-rounded p-button-success p-button mr-2"
                        onClick={() => handleNewTramoCuota(rowData)}
                        disabled={
                            rowData.tramo && rowData.tramo.includes("Cuota")
                        }
                        outlined
                        ></Button>
                        {rowData.tramo && rowData.tramo.includes("Cuota") && (
                        <Button
                            icon="pi pi-trash"
                            className="p-button-rounded p-button-danger p-button ml-2"
                            onClick={() => handleBorrarLinea(rowData, "unicos")}
                            outlined
                            disabled={loading ||
                            cotizacion?.estado.estado === "ANULADA" ||
                            cotizacion?.estado.estado === "ASIGNACIÓN" || 
                            cotizacion?.estado.estado === "RECHAZADA"
                            }
                        ></Button>
                        )}
                        
                        {/* SELECCION DE CUOTAS */}
                        <Dialog
                            visible={showTramoModalUnico}
                            onHide={() => {
                                setShowTramoModalUnico(false);
                            }}
                            className="p-fluid product-dialog"
                            modal
                            //k={false}
                        >
                        <div className="flex align-items-center justify-content-center text-center">
                            <div className="grid justify-content-center text-center">
                                <div className="col-12 justify-content-center text-center">
                                    <h5>
                                        Seleccione cantidad de cuotas para{" "}
                                        {nombreCuadro}
                                    </h5>
                                    <div>
                                    <InputNumber
                                        value={0}
                                        onChange={(e) => setCuotas(e.value)}
                                        locale="es-CL"
                                        maxFractionDigits={0}
                                        max={maxAmountOfCuotas}
                                    />
                                    <div className="field col-12 md:col-12">
                                        <Button
                                        icon={
                                            maxAmountOfCuotas !== 1
                                            ? "pi pi-check"
                                            : "pi pi-ban"
                                        }
                                        label={
                                            maxAmountOfCuotas !== 1
                                            ? "Confirmar"
                                            : "No puede agregar cuotas"
                                        }
                                        className="p-button-rounded p-button-success p-button mb-2 mt-2"
                                        onClick={() =>
                                            handleTramoConfirmacionCuota(itemCuotas)
                                        }
                                        disabled={
                                            1 >= cuotas ||
                                            loading ||
                                            maxAmountOfCuotas === 1
                                        }
                                        raised
                                        />
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </Dialog>
                    </>
                    )}
                />
                )}
            </DataTable>
            
            {/* FOOTER */}
            <div
                className="grid ml-2 mr-2 mb-4 mt-4"
                style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                }}
            ></div>

            {/* Tooltip para los iconos de información de las cabeceras */}
            <Tooltip target=".unicos-info-icon" position="top" />

            {/* Dialog calculadora tarifa cliente */}
            <CalculadoraTarifaDialog
                rowData={calcRow}
                monedaOptions={monedaOptions}
                usarCantidad={false}
                mostrarDiaria={false}
                mostrarDescuento={false}
                titulo="Calcular Tarifa Cliente"
                etiquetaMonto="Monto deseado"
                etiquetaMensual="Equivalente en UF"
                onHide={() => setCalcRow(null)}
                onAplicar={(tarifa, monedaSel) => {
                    handleTablaChange(calcRow, monedaSel, "unicos", "moneda");
                    handleTablaChange(calcRow, tarifa, "unicos", "tarifa_cliente");
                    setCalcRow(null);
                }}
            />
            </>
        )}
        </>
    );
};

export default ServiciosUnicosDataTable;